import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Flex, Image } from '@chakra-ui/react';

import useVerifyResetToken from 'Domain/reset-password/useVerifyResetToken';
import loginImage from 'Asset/image/login-image.jpg';
import { Condition } from 'Component/others';
import { useToast } from 'Store/toast';

import { useResetPasswordState } from './state';
import ResetPasswordProvider from './state';
import Form from './section/form';
import Head from './section/head';
import Success from './section/success';
import styles from './styles.module.css';

const ResetPassword = () => {
  const { onOpenToast } = useToast();
  const navigate = useNavigate();

  // Check if the token is valid
  const { error } = useVerifyResetToken();

  // Reset the state
  const { resetState, state } = useResetPasswordState();

  useEffect(() => resetState(), [resetState]);

  useEffect(() => {
    if (error) {
      const errorMessage = error?.response?.data?.errors[0]?.message ?? 'Invalid or expired token';

      onOpenToast({
        status: 'error',
        title: 'Error',
        description: errorMessage,
        duration: 3,
        alwaysShow: false,
      });

      navigate('/login');
    }
    /* eslint-disable-next-line */
  }, [error]);

  return (
    <Flex className={styles['reset-password__container']}>
      <Box className={styles['section__container--left']}>
        <Image src={loginImage} className={styles['reset-password__image']} />
      </Box>
      <Box className={styles['section__container--right']}>
        <Box className={styles['box__container']}>
          <Condition statement={!state?.isSuccess} fallback={<Success />}>
            <Head />
            <Form />
          </Condition>
        </Box>
      </Box>
    </Flex>
  );
};

const ResetPaswordContainer = () => <ResetPasswordProvider children={<ResetPassword />} />;

export default ResetPaswordContainer;
